// ✅ Scroll Reveal Setup (Reusable for homepage + dynamically loaded sections)
function setupScrollReveal() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('revealed');
            }
        });
    }, observerOptions);

    document.querySelectorAll('.scroll-reveal:not(.revealed)').forEach(el => {
        observer.observe(el);
    });
}

// ✅ Run on full page load (initial load)
window.addEventListener('load', setupScrollReveal);

// ✅ Run again when sections are dynamically loaded (Shopify homepage)
document.addEventListener('shopify:section:load', setupScrollReveal);

// ✅ Smooth scrolling for internal navigation
document.querySelectorAll('.nav-links a').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        if (
            this.hostname === window.location.hostname &&
            this.pathname === window.location.pathname &&
            this.hash
        ) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const navHeight = document.querySelector('.nav').offsetHeight;
                const offsetTop = targetElement.offsetTop;

                window.scrollTo({
                    top: offsetTop - navHeight,
                    behavior: 'smooth'
                });
            }
        }
    });
});

// ✅ Dynamic navbar background on scroll
window.addEventListener('scroll', () => {
    const nav = document.querySelector('.nav');
    if (window.scrollY > 50) {
        nav.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
        nav.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)';
    } else {
        nav.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
        nav.style.boxShadow = '0 1px 5px rgba(0,0,0,0.04)';
    }
});
